<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("header.information") }}</h1>

            <div class="row">
                <div class="col-sm-12">
                    <div class="bs-component">
                      <div id="info" class="alert alert-dismissible alert-light">
                          <p class="mb-0" v-for="(value, index) in infoList" :key="index">{{value}}</p>
                      </div>
                    </div>
                </div>
            </div>
            <confirmModal modId="md-err-top" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'
export default {
  components: {
    confirmModal
  },
  created () {
    // お知らせ取得
    var reqObj = {}
    var headers = {
      'Content-Type': 'application/json',
      'opid': this.$store.store.state.opId,
      'ticketid': this.$store.store.state.ticketId
    }
    this.$axios
      .post(window.END_POINT + '/master/toppage/select', reqObj, {
        'headers': headers
      })
      .then(res => {
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err-top')
          }
        } else {
          // お知らせ展開
          var dataList = res.data.notifyInfo
          for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i].contents
            this.infoList.push(data)
          }
          if (dataList.length === 0) {
            this.infoList.push(this.$i18n.t('menu.no_information'))
          }
        }
      })
      .catch(err => {
        console.log(err)
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('common.unexpected_error')
        this.$bvModal.show('md-err-top')
      })
  },
  methods: {
    errConfirm: function () {
      this.$bvModal.hide('md-err-top')
    }
  },
  data () {
    return {
      el: '#info',
      infoList: [
      ],
      errMsg: '',
      errSbj: ''
    }
  }
}
</script>

<style scoped>

.fc-test-css * {
  outline: 1px solid rgba(255, 0, 212, 0.1);
  background: rgba(255, 0, 212, 0.01);
}
.fc-test-css-h {
  font-size: 1rem;
  margin: 2rem 0 1rem;
  padding: 0.5rem;
  border-bottom: 1px solid rgb(194, 231, 223);
  color: rgb(112, 190, 170);
}
.bs-docs-section h2[id] {
  margin-top: 3rem;
  margin-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Top.vue